module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Card', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("\n        Surat Jalan Belum Di Print\n    ")]), _vm._v(" "), _c('Row', {
    staticClass: "code-row-bg",
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('Col', {
    attrs: {
      "span": "3"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "Marked By",
      "clearable": ""
    },
    model: {
      value: (_vm.searchUsername),
      callback: function($$v) {
        _vm.searchUsername = $$v
      },
      expression: "searchUsername"
    }
  })], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "20"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "clearable": "",
      "loading": _vm.loadingGetSuratJalan,
      "icon": "ios-search-strong"
    },
    on: {
      "click": _vm.getReadyPrint
    }
  }, [(!_vm.loadingGetSuratJalan) ? _c('span', [_vm._v("Cari")]) : _c('span', [_vm._v("Wait.")])])], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('Card', [_c('Alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.suratJalan.length > 0),
      expression: "suratJalan.length > 0"
    }],
    attrs: {
      "type": "success"
    }
  }, [_vm._v("Showing " + _vm._s(_vm.suratJalanToShow.length) + " from " + _vm._s(_vm.suratJalan.length) + " Surat Jalan - Server Location  : " + _vm._s(_vm.serverIP) + ", Printer Name : " + _vm._s(this.printer.printername))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "flex-container"
  }, _vm._l((_vm.suratJalan), function(suratJalan, index) {
    return _c('div', {
      key: index
    }, [_c('div', [_c('div', [_c('font', {
      staticStyle: {
        "color": "blue"
      }
    }, [_vm._v(" " + _vm._s(suratJalan.marking) + " ")]), _vm._v(" "), (suratJalan.isLoadingPrinted) ? _c('span', [_c('button', {
      staticStyle: {
        "width": "50px",
        "background-color": "yellow"
      },
      on: {
        "click": function($event) {
          return _vm.doPrinting(index)
        }
      }
    }, [_vm._v("Print")])]) : (suratJalan.isSuccessPrinted) ? _c('span', [_c('button', {
      staticStyle: {
        "width": "50px"
      },
      attrs: {
        "disabled": ""
      },
      on: {
        "click": function($event) {
          return _vm.doPrinting(index)
        }
      }
    }, [_vm._v("Print")])]) : (suratJalan.isErrorPrinted) ? _c('span', [_c('button', {
      staticStyle: {
        "width": "50px",
        "background-color": "red"
      },
      on: {
        "click": function($event) {
          return _vm.doPrinting(index)
        }
      }
    }, [_vm._v("Print")])]) : _c('span', [_c('button', {
      staticStyle: {
        "width": "50px"
      },
      on: {
        "click": function($event) {
          return _vm.doPrinting(index)
        }
      }
    }, [_vm._v("Print")])]), _vm._v(" "), _c('hr'), _vm._v("\n                      Marked by : " + _vm._s(suratJalan.markedprintedby) + " "), _c('br'), _vm._v("\n                      Nama : " + _vm._s(suratJalan.markinginfoname) + " "), _c('br'), _vm._v("\n                      Alamat Kirim 1 : " + _vm._s(suratJalan.markinginfoaddress1) + "  "), _c('br'), _vm._v("\n                      Alamat Kirim 2 : " + _vm._s(suratJalan.markinginfoaddress2) + "  "), _c('br'), _vm._v("\n\n                      Telepon : " + _vm._s(suratJalan.markinginfophone1) + " / " + _vm._s(suratJalan.markinginfophone2) + "  "), _c('br'), _vm._v("\n                      Partai : P." + _vm._s(suratJalan.containercode) + " "), _c('br'), _vm._v("\n                      Load : " + _vm._s(suratJalan.loaddate) + "  "), _c('br'), _vm._v("\n                      Volume : " + _vm._s(suratJalan.volumesum) + "  "), _c('br'), _vm._v("\n                      GW : " + _vm._s(suratJalan.sentctnscurrent) + " "), _c('br')], 1)])])
  }), 0)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69f51d5c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/surat/SuratJalanBelumPrint.vue
// module id = 1823
// module chunks = 1